import { Component } from '@angular/core';

@Component({
  selector: 'app-cards5-examples-32',
  templateUrl: './cards5-examples-32.component.html'
})
export class Cards5Examples32Component {}
